module.exports = __webpack_public_path__ + "static/media/home-alt.072444bf.svg";